// ************ ==== >>>> Page <<<< ==== ************//
import Login from "../pages/website/Login";
import Forgotpassword from "../pages/website/Forgotpassword.jsx";
import Resetpassword from "../pages/website/Resetpassword.jsx";
import Dashboardnavbar from "../layout/Dashboardnavbar.jsx";

// ************ ==== >>>> Site Dashboard <<<< ==== ************//

// import ExpenseTracking from "../pages/sitedashboard/Main/ExpenseTracking.jsx";

import CertficateAccess from "../components/SiteManagement/CertificateAccess.jsx";

import BdDashboard from "../pages/bddashboard/BdDashboard.jsx";

import CertificationDashboard from "../pages/certificationsportal/CertificationDashboard.jsx";
import CertificationbdDashboard from "../pages/certificationbdportal/CertificationbdDashboard.jsx";

import Bid from "../components/Bid/Bid.jsx";
import BidDetails from "../components/Bid/Biddetails.jsx";
import BidList from "../components/Bid/Bidlist.jsx";
import TargetBidList from "../components/Bid/TargetBidlist.jsx";

import FinalizeBidList from "../components/Bid/FinalizeBidList.jsx";
import JvPartner from "../components/Bid/JvPartner.jsx";

import BidTenderManagement from "../components/Bid/BidTenderManagement.jsx";

import AllTender from "../components/Bid/AllTender.jsx";
import SubmittedTender from "../components/Bid/SubmittedTender.jsx";
import { Cv } from "../components/Bid/Cv.jsx";
import SearchTender from "../components/Bid/SearchTender.jsx";

import CertificationAccessCvTeamDashboard from "../pages/CertificationAccessCvTeamportal/CertificationAccessCvTeamDashboard.jsx";
import CertificationAccessCvTeamHeadDashboard from "../pages/CertificationAccessCvTeamHead/CertificationAccessCvTeamHeadDashboard.jsx";
import CertificationAccessDocumentTeamDashboard from "../pages/CertificationAccessDocumentTeamportal/CertificationAccessDocumentTeamDashboard.jsx";
import CertificationAccessDocumentTeamHeadDashboard from "../pages/CertificationAccessDocumentTeamHeadportal/CertificationAccessDocumentTeamHeadDashboard.jsx";
// whatsappp messenger import

import WhatsAppChat from "../components/Bid/Whatsapp.jsx";

import Designation from "../components/Bid/Designation.jsx";
import BdCountDashboard from "../components/Bid/BdCountDashboard.jsx";
import BdAccountDashboard from "../pages/bdaccountportal/BdAccountDashboard.jsx";
import Prebidbddashboard from "../pages/prebidbddashboard/Prebidbddashboard.jsx";
import Screeningteambddashboard from "../pages/screeningteambddashboard/Screeningteambddashboard.jsx";
// import TenderDashboard from "../pages/Dashboard/TenderDashboard.jsx";
import TenderDashboard from "../pages/testingDashboard/TenderDashboard.jsx";
import TaskPlanner from "../components/TaskPlanner/TaskPlanner.jsx";
export const routingData = [
  {
    role: "",
    isProtected: false,
    defaultRoute: "/",
    routes: [
      {
        path: "",
        component: <Login />,
      },
      {
        path: "login",
        component: <Login />,
      },
      {
        path: "forgotpassword/",
        component: <Forgotpassword />,
      },
      {
        path: "resetpassword/:uidb64/:token/",
        component: <Resetpassword />,
      },
      {
        path: "Dashboardnavbar",
        component: <Dashboardnavbar />,
      },
    ],
  },

  {
    role: "BD",
    isProtected: true,
    defaultRoute: "bd/searchTender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "certification",
            component: <CertficateAccess />,
          },

          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "taskPlanner",
            component: <TaskPlanner />,
          },
          {
            path: "whatsapp",
            component: <WhatsAppChat />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },
          {
            path: "bidList",
            component: <BidList />,
          },
          {
            path: "targetBidList",
            component: <TargetBidList />,
          },
          {
            path: "finalBidList",
            component: <FinalizeBidList />,
          },
          {
            path: "partnermanagement",
            component: <JvPartner />,
          },
          // {
          //   path: "allTender",
          //   component: <AllTender />,
          // },
          {
            path: "searchTender",
            component: <SearchTender />,
          },
          {
            path: "cv",
            component: <Cv />,
          },
          {
            path: "designation",
            component: <Designation />,
          },
          {
            path: "bg",
            component: <SubmittedTender />,
          },
        ],
        path: "bd",
        component: <BdDashboard />,
      },
    ],
  },

  {
    role: "CertificationAccess",
    isProtected: true,
    defaultRoute: "certificaionadminaccess/dashboard",
    nestedRoutes: [
      {
        routes: [
          {
            path: "BdDashboard",
            component: <BdCountDashboard />,
          },
          {
            path: "certification",
            component: <CertficateAccess />,
          },

          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "taskPlanner",
            component: <TaskPlanner />,
          },
          {
            path: "messenger",
            component: <WhatsAppChat />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },
          {
            path: "bidList",
            component: <BidList />,
          },
          {
            path: "targetBidList",
            component: <TargetBidList />,
          },
          {
            path: "finalBidList",
            component: <FinalizeBidList />,
          },
          {
            path: "partnermanagement",
            component: <JvPartner />,
          },
          // {
          //   path: "allTender",
          //   component: <AllTender />,
          // },
          {
            path: "searchTender",
            component: <SearchTender />,
          },
          {
            path: "cv",
            component: <Cv />,
          },
          {
            path: "designation",
            component: <Designation />,
          },
          {
            path: "bg",
            component: <SubmittedTender />,
          },
          // {
          //   path: "dashboard",
          //   component: <TenderDashboard />,
          // },
          {
            path: "dashboard",
            component: <TenderDashboard />,
          },
        ],
        path: "certificaionadminaccess",
        component: <CertificationDashboard />,
      },
    ],
  },
  {
    role: "BdDashbaordAccount",
    isProtected: true,
    defaultRoute: "bddashbaordaccount/bg",
    nestedRoutes: [
      {
        routes: [
          {
            path: "bg",
            component: <SubmittedTender />,
          },
        ],
        path: "bddashbaordaccount",
        component: <BdAccountDashboard />,
      },
    ],
  },
  {
    role: "BdDashboardPrebid",
    isProtected: true,
    defaultRoute: "bddashboardprebid/tender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "tender",
            component: <Bid />,
          },
          {
            path: "taskPlanner",
            component: <TaskPlanner />,
          },
        ],
        path: "bddashboardprebid",
        component: <BdAccountDashboard />,
      },
    ],
  },
  {
    role: "ScreeningTeam",
    isProtected: true,
    defaultRoute: "screeningteam/tender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "searchTender",
            component: <SearchTender />,
          },
          {
            path: "tender",
            component: <Bid />,
          },
          {
            path: "taskPlanner",
            component: <TaskPlanner />,
          },
        ],
        path: "screeningteam",
        component: <Screeningteambddashboard />,
      },
    ],
  },
  {
    role: "CertificationAccessBd",
    isProtected: true,
    defaultRoute: "certificaionbdaccess/searchTender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "taskPlanner",
            component: <TaskPlanner />,
          },
          {
            path: "messenger",
            component: <WhatsAppChat />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },

          {
            path: "searchTender",
            component: <SearchTender />,
          },

          // {
          //   path: "tender",
          //   component: <Tender />,
          // },
        ],
        path: "certificaionbdaccess",
        component: <CertificationbdDashboard />,
      },
    ],
  },
  {
    role: "CertificationAccessDocumentTeamHead",
    isProtected: true,
    defaultRoute: "CertificationAccessDocumentTeamHead/searchTender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },

          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "taskPlanner",
            component: <TaskPlanner />,
          },
          {
            path: "messenger",
            component: <WhatsAppChat />,
          },
          {
            path: "searchTender",
            component: <SearchTender />,
          },

          // {
          //   path: "tender",
          //   component: <Tender />,
          // },
        ],
        path: "CertificationAccessDocumentTeamHead",
        component: <CertificationAccessDocumentTeamHeadDashboard />,
      },
    ],
  },
  {
    role: "CertificationAccessDocumentTeam",
    isProtected: true,
    defaultRoute: "CertificationAccessDocumentTeam/searchTender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "taskPlanner",
            component: <TaskPlanner />,
          },
          {
            path: "messenger",
            component: <WhatsAppChat />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },

          {
            path: "searchTender",
            component: <SearchTender />,
          },

          // {
          //   path: "tender",
          //   component: <Tender />,
          // },
        ],
        path: "CertificationAccessDocumentTeam",
        component: <CertificationAccessDocumentTeamDashboard />,
      },
    ],
  },
  {
    role: "CertificationAccessCvTeam",
    isProtected: true,
    defaultRoute: "CertificationAccessCvTeam/searchTender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "taskPlanner",
            component: <TaskPlanner />,
          },
          {
            path: "messenger",
            component: <WhatsAppChat />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },

          {
            path: "searchTender",
            component: <SearchTender />,
          },

          {
            path: "designation",
            component: <Designation />,
          },
          // {
          //   path: "tender",
          //   component: <Tender />,
          // },
        ],
        path: "CertificationAccessCvTeam",
        component: <CertificationAccessCvTeamDashboard />,
      },
    ],
  },
  {
    role: "CertificationAccessCvTeamHead",
    isProtected: true,
    defaultRoute: "CertificationAccessCvTeamHead/searchTender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "taskPlanner",
            component: <TaskPlanner />,
          },
          {
            path: "messenger",
            component: <WhatsAppChat />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },

          {
            path: "designation",
            component: <Designation />,
          },

          {
            path: "searchTender",
            component: <SearchTender />,
          },

          // {
          //   path: "tender",
          //   component: <Tender />,
          // },
        ],
        path: "CertificationAccessCvTeamHead",
        component: <CertificationAccessCvTeamHeadDashboard />,
      },
    ],
  },
];
